export interface UptimeCheck {
  id: string;
  site_id: string;
  status: 'up' | 'down';
  status_code: number | null;
  total_time_ms: number | null;
  dns_ms: number | null;
  tcp_ms: number | null;
  ssl_ms: number | null;
  server_ms: number | null;
  download_ms: number | null;
  server_ip: string | null;
  redirects: number;
  created_at: string;
}

export type TimeRange = '3h' | '24h' | '7d' | '30d';

export interface TimeRangeOption {
  label: string;
  value: TimeRange;
  hours: number;
}

export const TIME_RANGE_OPTIONS: TimeRangeOption[] = [
  { label: 'Last 3 hours', value: '3h', hours: 3 },
  { label: 'Last 24 hours', value: '24h', hours: 24 },
  { label: 'Last 7 days', value: '7d', hours: 168 },
  { label: 'Last 30 days', value: '30d', hours: 720 },
];

export function formatResponseTime(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return 'N/A';
  if (ms >= 1000) return `${(ms / 1000).toFixed(2)}s`;
  return `${Math.round(ms)}ms`;
}

export function formatCheckDate(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}
